export const enum Routes {
    Home = 'home', // blank
    PublicEvent = 'public_event', // dynamic
    PrivateEvent = 'private_event', // dynamic
}
